let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iSzDM")).then(() => parcelRequire('8GNxX'));